var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "43px",
    viewBox: "0 0 44 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "40A4B387-3A93-4FC3-AB46-2AB8944D5979") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Other-pages",
    transform: "translate(-108.000000, -151.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Xnix/Line/Parcel",
    transform: "translate(110.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.2634483 L2.85714286,1.37931034 L14.2857143,1.37931034 M0,13.2634483 L0,40 L40,40 L40,13.2634483 M0,13.2634483 L14.2857143,13.2634483 M14.2857143,13.2634483 L25.7142857,13.2634483 M14.2857143,13.2634483 L14.2857143,1.37931034 M14.2857143,13.2634483 L14.2857143,23.4482759 L20,20.6896552 L25.7142857,23.4482759 L25.7142857,13.2634483 M14.2857143,1.37931034 L25.7142857,1.37931034 M40,13.2634483 L37.1428571,1.37931034 L25.7142857,1.37931034 M40,13.2634483 L25.7142857,13.2634483 M25.7142857,13.2634483 L25.7142857,1.37931034",
    id: "Vector-11"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsIcon);
export default __webpack_public_path__ + "static/media/Products Icon.9e74346f5f6624fd95032ded9910e5e4.svg";
export { ForwardRef as ReactComponent };